import React from 'react';
import {
  FileImageOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  FilePdfOutlined,
  FileZipOutlined,
  FileUnknownOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  FileTextOutlined,
} from '@ant-design/icons';

// 文件类型到 SVG 图标的映射
export const FILE_ICON_MAP: Record<string, React.ReactNode> = {
  word: <FileWordOutlined style={{ fontSize: 48 }} />,
  excel: <FileExcelOutlined style={{ fontSize: 48 }} />,
  ppt: <FilePptOutlined style={{ fontSize: 48 }} />,
  pdf: <FilePdfOutlined style={{ fontSize: 48 }} />,
  zip: <FileZipOutlined style={{ fontSize: 48 }} />,
  rar: <FileZipOutlined style={{ fontSize: 48 }} />,
  image: <FileImageOutlined style={{ fontSize: 48 }} />,
  video: <VideoCameraOutlined style={{ fontSize: 48 }} />,
  audio: <AudioOutlined style={{ fontSize: 48 }} />,
  document: <FileTextOutlined style={{ fontSize: 48 }} />,
  other: <FileUnknownOutlined style={{ fontSize: 48 }} />,
};

export function getFileIconByType(type?: string): React.ReactNode {
  if (!type) return FILE_ICON_MAP.other;
  return FILE_ICON_MAP[type] || FILE_ICON_MAP.other;
}
